<h2 mat-dialog-title>{{ popupTitle }}</h2>

<mat-dialog-content>
  <p>{{ popupDescription }}</p>
</mat-dialog-content>

<mat-dialog-actions class="idle__popup--buttons">
  <button class="mat-raised-button mat-accent" (click)="okay()">Okay</button>
</mat-dialog-actions>
